import type { ComposerTranslation } from 'vue-i18n'
import {
  ActionState,
  DirectionState,
  frequencyState,
  PortTypeState,
  ProtocolState,
} from './types'

/** 执行动作等下拉/表格展示（与 locales ipAddressBlocking.* 一致） */
export function getActionStateLabelMap(t: ComposerTranslation): Record<ActionState, string> {
  return {
    [ActionState.just_record]: t('ipAddressBlocking.actionAllow'),
    [ActionState.stop_blocking]: t('ipAddressBlocking.actionBlockAndRecord'),
    [ActionState.record_warning]: t('ipAddressBlocking.actionWarnBlockAndRecord'),
  }
}

export function getDirectionStateLabelMap(t: ComposerTranslation): Record<DirectionState, string> {
  return {
    [DirectionState.bidirectional]: t('ipAddressBlocking.directionBidirectional'),
    [DirectionState.inbound]: t('ipAddressBlocking.directionInbound'),
    [DirectionState.outbound]: t('ipAddressBlocking.directionOutbound'),
  }
}

/** 策略表单「拦截方向」长文案 */
export function getDirectionStateDictLongMap(t: ComposerTranslation): Record<DirectionState, string> {
  return {
    [DirectionState.bidirectional]: t('ipAddressBlocking.directionBidirectionalLong'),
    [DirectionState.inbound]: t('ipAddressBlocking.directionInboundLong'),
    [DirectionState.outbound]: t('ipAddressBlocking.directionOutboundLong'),
  }
}

export function getProtocolStateLabelMap(t: ComposerTranslation): Record<ProtocolState, string> {
  return {
    [ProtocolState.arbitrary_agreement]: t('ipAddressBlocking.protocolAny'),
    [ProtocolState.TCP]: 'TCP',
    [ProtocolState.UDP]: 'UDP',
  }
}

export function getFrequencyStateLabelMap(t: ComposerTranslation): Record<frequencyState, string> {
  return {
    [frequencyState.day]: t('ipAddressBlocking.freqEveryDay'),
    [frequencyState.week]: t('ipAddressBlocking.freqEveryWeek'),
    [frequencyState.month]: t('ipAddressBlocking.freqEveryMonth'),
  }
}

export function getPortTypeStateLabelMap(t: ComposerTranslation): Record<PortTypeState, string> {
  return {
    [PortTypeState.normal_port]: t('ipAddressBlocking.portTypePreset'),
    [PortTypeState.custom_port]: t('ipAddressBlocking.portTypeCustomPort'),
  }
}
